import { computed } from 'vue';
import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for End Chat button customisation (chatbot END_CHAT_BUTTON block/section).
 * Returns background, text and border colors for the end chat button.
 */
export const useEndChatButtonCustomisation = () => {
  const { getField } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT,
    sectionKey: PUI.CHATBOT_SECTION_KEYS.END_CHAT_BUTTON,
    blockKey: PUI.CHATBOT_BLOCK_KEYS.END_CHAT_BUTTON,
  });

  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_BACKGROUND_COLOR);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_TEXT_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BUTTON_BORDER_COLOR);

  const endChatCustomisation = computed(() => ({
    backgroundColor: backgroundColor.value,
    textColor: textColor.value,
    borderColor: borderColor.value,
  }));

  return {
    endChatCustomisation,
  };
};
